import { H4, LI, P, UL } from "../../../../AbstractElements";
import { Href } from "../../../../Constant";
import { InformationCommonPropsType } from "../../../../Type/SearchType";
import ShowRatings from "../ShowRatings";

const InformationCommon = ({ item }: InformationCommonPropsType) => {
  return (
    <div className="info-block">
      <a href={Href}>{item.url}</a>
      <H4>{item.title}</H4>
      <P>{item.detail}</P>
      <div className="star-ratings">
        <UL className="search-info simple-list d-flex flex-row">
          {item.showStar ? <ShowRatings item={item.showStar} /> : ""}
          <LI>{item.star}</LI>
          <LI>{item.vote}</LI>
          <LI>{item.news}</LI>
        </UL>
      </div>
    </div>
  );
};

export default InformationCommon;
